import React from "react";
import { Field, ErrorMessage } from "formik";
import Checkbox from "src/components/Forms/FormikCheckbox";
import CheckboxGroup from "src/components/Forms/FormikCheckboxGroup";
import { generalInfoType } from "ps-shared";
import FormikMultiSelect, { SelectOption } from "src/components/Forms/FormikMultiSelect";
import { FormikMultiCreateSelect } from "src/components/Forms/FormikMultiCreateSelect";
import { AdminService } from "src/services/AdminService";
import Loading from "src/components/General/Loading";
import { FormGroup, Label, UncontrolledTooltip } from "reactstrap";
import languageList from "ps-shared/models/forms/languages.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// tslint:disable-next-line:no-empty-interface
export interface GeneralInfoFormCb {}

interface GeneralInfoProps {
  values: generalInfoType;
}
interface GeneralInfoState {
  languageOptions: SelectOption[];
  practitioners: SelectOption[];
  practitionerErr: boolean;
  practitionerLoading: boolean;
}

export class GeneralInfoForm extends React.Component<GeneralInfoProps, GeneralInfoState> {
  constructor(props: GeneralInfoProps) {
    super(props);
    this.state = {
      languageOptions: languageList.map((language: any) => {
        const opt = {} as SelectOption;
        opt.label = language.name;
        opt.value = language.code;
        return opt;
      }),
      practitioners: [],
      practitionerErr: false,
      practitionerLoading: true,
    };
    AdminService.getAllProfilesByType("practitioner")
      .then((data: any) => {
        this.setState({
          practitioners: data.profiles.map((d: any) => {
            const opt = {} as SelectOption;
            opt.label = d.name;
            opt.value = d.slug;
            return opt;
          }),
          practitionerLoading: false,
        });
      })
      .catch((error: any) => {
        console.error("unable to get profiles by type");
        console.error(error);
        this.setState({
          practitionerErr: true,
          practitionerLoading: false,
        });
      });
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormGroup className="mb-3">
          <Label for="name">Clinic Name:</Label>
          <br />
          <Field
            placeholder="Clinic Name"
            type="text"
            component="input"
            name="name"
            className="form-control"
            autoComplete="clinicName"
          />
          <ErrorMessage name="name" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="email">Email:</Label>
          <br />
          <Field
            placeholder="Clinic email"
            type="text"
            name="email"
            component="input"
            className="form-control"
            autoComplete="email"
          />
          <ErrorMessage name="email" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="phone">Phone:</Label>
          <br />
          <Field
            placeholder="Phone"
            type="text"
            name="phone"
            component="input"
            className="form-control"
            autoComplete="phone"
          />
          <ErrorMessage name="phone" component="div" className="position-relative form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="preferredContact">Preferred Contact:</Label>
          <br />
          <CheckboxGroup name="preferredContact" value="email" label="Email" />
          <CheckboxGroup name="preferredContact" value="phone" label="Phone" />
          <ErrorMessage name="preferredContact" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="websiteTT">
            Copy/paste the url here. It requires the full link from your browser including http:// or https://
          </UncontrolledTooltip>
          <Label for="web">Website(s):</Label>&nbsp;
          <span id="websiteTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          <FormikMultiCreateSelect
            options={[]}
            value={this.props.values.web}
            name="web"
            noOptionsMessage="Add your website(s)"
            validationFunc={(value: string): boolean => {
              try {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const url = new URL(value);
                return true;
              } catch {
                return false;
              }
            }}
            customErr="Invalid URL, please be sure to prefix with the protocol eg http:// or https://"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="languages">Languages Spoken:</Label>
          <br />
          <FormikMultiSelect
            options={this.state.languageOptions}
            value={this.props.values.languages}
            name="languages"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="practitioners">Practitioners:</Label>
          <br />
          {this.state.practitionerLoading && <Loading />}
          {!this.state.practitionerLoading && !this.state.practitionerErr && (
            <>
              <FormikMultiSelect
                options={this.state.practitioners}
                value={this.props.values.practitioners}
                name="practitioners"
              />
            </>
          )}
          {!this.state.practitionerLoading && this.state.practitionerErr && (
            <>
              <div className="form-feedback">
                There was an error loading the practitioners, please contact{" "}
                <a href="mailto:help@psychedelic.support">Psychedelic Support help desk</a> if you would like to add
                practioners to your clinic
              </div>
            </>
          )}
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="codeOfConduct">Code of Conduct:</Label>
          <br />
          <Checkbox name="codeOfConduct" value={true} label="I agree to the Code of Conduct" />
          <ErrorMessage name="codeOfConduct" component="div" className="form-feedback" />
        </FormGroup>
      </>
    );
  }
}
